import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { faqItems } from '../data/faq';
export function Faq() {
  const [openId, setOpenId] = useState<string | null>(faqItems[0].id);
  return <section className="border-t border-white/10 bg-navy-800" data-id="element-61" data-mp="1lctvwo09f1hg">
      <div className="relative z-10 mx-auto w-full max-w-3xl px-4 py-14 sm:px-6 sm:py-20" data-id="element-62" data-mp="1gcpg7076easa">
        <h2 className="text-2xl font-extrabold tracking-tight text-white sm:text-3xl" data-id="element-63" data-mp="1gauu3ik64cmm">
          Questions, Answered
        </h2>

        <ul className="mt-8 border-t border-white/10" data-id="element-64" data-mp="2913cnbim8z1q">
          {faqItems.map(item => {
          const isOpen = openId === item.id;
          return <li key={item.id} className="border-b border-white/10" data-id="element-65" data-mp="24438j65bu6d9">
                <h3 data-id="element-66" data-mp="1z2nit0s7fboj">
                  <button type="button" aria-expanded={isOpen} aria-controls={`faq-panel-${item.id}`} onClick={() => setOpenId(isOpen ? null : item.id)} className="flex w-full items-center justify-between gap-4 py-4 text-left transition-colors duration-150 ease-out hover:text-brand-emerald focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-emerald" data-id="element-67" data-mp="1z5jj2vriycg5">
                    <span className="text-base font-semibold text-white sm:text-lg" data-id="element-68" data-mp="kil548nwvien">
                      {item.question}
                    </span>
                    <span className="flex h-7 w-7 shrink-0 items-center justify-center border border-white/20 text-brand-emerald" aria-hidden="true" data-id="element-69" data-mp="6pve1ptiznao">
                      {isOpen ? <MinusIcon className="h-4 w-4" strokeWidth={2.5} data-id="element-70" data-mp="1rtyhevb663y" /> : <PlusIcon className="h-4 w-4" strokeWidth={2.5} data-id="element-71" data-mp="3jxggg1w2igbj" />}
                    </span>
                  </button>
                </h3>
                <div id={`faq-panel-${item.id}`} hidden={!isOpen} className="pb-5 pr-10 text-sm leading-relaxed text-slate-300 sm:text-base" data-id="element-72" data-mp="3o1ed85xx7f1f">
                  {item.answer}
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}